import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import categoryReducer from "./state/categoryState";
import productReducer from "./state/productState";
import restaurantReducer from "./state/restaurantState";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";

const store = configureStore({
  reducer: {
    products: productReducer,
    categories: categoryReducer,
    restaurants: restaurantReducer,
  },
});

const queryParams = new URLSearchParams(window.location.search);
// const id = queryParams.get("id");
const id = "MP362";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App id={id} />
  </Provider>
);
